import { render } from "./ContentDocument.vue?vue&type=template&id=07318231&scoped=true"
import script from "./ContentDocument.vue?vue&type=script&lang=js"
export * from "./ContentDocument.vue?vue&type=script&lang=js"

import "./ContentDocument.vue?vue&type=style&index=0&id=07318231&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07318231"]])

export default __exports__